import { DependenciesFilterSwitch } from './DependenciesFilterSwitch';

export default DependenciesFilterSwitch;
